import type { IntlShape } from 'react-intl';

import { getBannerHeaders } from '@/pages/PromotionalBanners/utils/getBannerHeaders';

export const getBrandPromotionalBannerHeaders = (intl: IntlShape) =>
    getBannerHeaders(intl, {
        intlPrefix: 'brandPromotionalBanner',
        linkColumnKey: 'brandPromotionalBanner.table.link',
        statusWidth: 180,
    });
